import React from 'react'
import { hydrate, render } from 'react-dom'
import './index.css'
import AppWrapper from './AppWrapper'
import { unregister as unregisterServiceWorker } from './registerServiceWorker'
import 'react-dates/initialize'
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'

// Polyfill for "forEach" method
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

const rootElement = document.getElementById('root')

if (rootElement.hasChildNodes()) {
  hydrate(
    <BrowserRouter>
      <ScrollToTop>
        <AppWrapper />
      </ScrollToTop>
    </BrowserRouter>, rootElement
  )
} else {
  render(
    <BrowserRouter>
      <ScrollToTop>
        <AppWrapper />
      </ScrollToTop>
    </BrowserRouter>, rootElement
  )
}


unregisterServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js